export const HIERARCHY_WIDTH_KEY = "modelvista-create-hierarchy-width";
export const DEFAULT_HIERARCHY_WIDTH = 220;
export const MIN_HIERARCHY_WIDTH = 180;

export function hierarchyWidthLimit(workspaceWidth) {
    const inspectorWidth = workspaceWidth <= 1050 ? 250 : 288;
    return Math.max(MIN_HIERARCHY_WIDTH, Math.min(600, workspaceWidth - inspectorWidth - 300));
}

export function clampHierarchyWidth(width, workspaceWidth) {
    const value = Number(width);
    return Math.round(Math.min(hierarchyWidthLimit(workspaceWidth), Math.max(MIN_HIERARCHY_WIDTH,
        Number.isFinite(value) && value > 0 ? value : DEFAULT_HIERARCHY_WIDTH)));
}

export function loadHierarchyWidth(storage) {
    try { return clampHierarchyWidth(storage.getItem(HIERARCHY_WIDTH_KEY), 1600); }
    catch { return DEFAULT_HIERARCHY_WIDTH; }
}

export function saveHierarchyWidth(storage, width) {
    try { storage.setItem(HIERARCHY_WIDTH_KEY, String(width)); }
    catch { /* Resizing remains available when browser storage is blocked. */ }
}
